import CrmContactSession from "./session/model-session";
import CustomFieldsProxy from "../../custom-fields-proxy";

export default class CrmContact extends CrmContactSession {

    public phone              : string | null
    public email              : string | null
    public notes              : string | null
    public customFieldsData   : CustomFieldsData | null

    constructor(data:any) {
        super(data);

        this.phone              = data['phone'];
        this.email              = data['email'];
        this.notes              = data['notes'];
        this.customFieldsData   = data['customFieldsData'];

        return new Proxy(this, CustomFieldsProxy);
    }

    save() {
        const params = {}

        this.updatedFields.forEach((fieldName) => {
            // @ts-ignore
            params[fieldName] = this[fieldName];
        })

        return gd.api.CRM.updateContact(this.id, params);
    }

}
